import {
  Checkbox,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import { useCallback } from "react";
import { ApartmentUserPermissions } from "../../../../graphql/models";

export type PermissionsPickerProps = {
  permissions: ApartmentUserPermissions;
  onPermissionsChange(permissions: ApartmentUserPermissions): void;
};

export default function PermissionsPicker(props: PermissionsPickerProps) {
  const {
    permissions = {
      canReserveAmenities: false,
      domotics: {
        alarm: false,
        clima: false,
        lights: false,
        shutters: false,
      },
    },
    onPermissionsChange,
  } = props;

  const toggleCanReserveAmenitiesChange = useCallback(() => {
    const fieldValue = permissions.canReserveAmenities;

    onPermissionsChange({
      ...permissions,
      canReserveAmenities: !fieldValue,
    });
  }, [permissions, onPermissionsChange]);

  const toggleDomoticsFieldChange = useCallback(
    (fieldName: string) => {
      const fieldValue = permissions.domotics[fieldName];

      onPermissionsChange({
        ...permissions,
        domotics: {
          ...permissions.domotics,
          [fieldName]: !fieldValue,
        },
      });
    },
    [permissions, onPermissionsChange]
  );

  return (
    <List dense style={{ width: "100%" }}>
      <ListItem
        key={"permissions-amenities"}
        dense
        button
        onClick={() => void 0}
      >
        <ListItemIcon>
          <Checkbox
            edge="start"
            checked={permissions.canReserveAmenities}
            onChange={toggleCanReserveAmenitiesChange}
            tabIndex={-1}
            disableRipple
          />
        </ListItemIcon>
        <ListItemText primary={`Può prenotare le amenities`} />
      </ListItem>
      <ListItem
        key={"permissions-domotics-lights"}
        dense
        button
        onClick={() => void 0}
      >
        <ListItemIcon>
          <Checkbox
            edge="start"
            checked={permissions.domotics.lights}
            onChange={() => toggleDomoticsFieldChange("lights")}
            tabIndex={-1}
            disableRipple
          />
        </ListItemIcon>
        <ListItemText primary={`Può gestire le luci`} />
      </ListItem>
      <ListItem
        key={"permissions-domotics-clima"}
        dense
        button
        onClick={() => void 0}
      >
        <ListItemIcon>
          <Checkbox
            edge="start"
            checked={permissions.domotics.clima}
            onChange={() => toggleDomoticsFieldChange("clima")}
            tabIndex={-1}
            disableRipple
          />
        </ListItemIcon>
        <ListItemText primary={`Può controllare il clima`} />
      </ListItem>
      <ListItem
        key={"permissions-domotics-alarm"}
        dense
        button
        onClick={() => void 0}
      >
        <ListItemIcon>
          <Checkbox
            edge="start"
            checked={permissions.domotics.alarm}
            onChange={() => toggleDomoticsFieldChange("alarm")}
            tabIndex={-1}
            disableRipple
          />
        </ListItemIcon>
        <ListItemText primary={`Può attivare l'allarme`} />
      </ListItem>
      <ListItem
        key={"permissions-domotics-shutters"}
        dense
        button
        onClick={() => void 0}
      >
        <ListItemIcon>
          <Checkbox
            edge="start"
            checked={permissions.domotics.shutters}
            onChange={() => toggleDomoticsFieldChange("shutters")}
            tabIndex={-1}
            disableRipple
          />
        </ListItemIcon>
        <ListItemText primary={`Può controllare le tapparelle`} />
      </ListItem>
    </List>
  );
}
